import {
  AddShoppingCartOutlined,
  AutoGraphOutlined,
  CardGiftcardOutlined,
  FactCheckOutlined,
  FireTruckOutlined,
  Inventory2Outlined,
  LibraryAddOutlined,
  MedicalInformationOutlined,
  PaymentOutlined,
  PeopleAltOutlined,
  PercentOutlined,
  PersonAddAlt1Outlined,
  PostAddOutlined,
} from '@mui/icons-material';

import { useSelector } from 'react-redux';
import { decodeToken, secondaryPermission } from '../../utils/settings';
import { useEffect, useState } from 'react';

export const MODULE_TO_SECTION = {
  'business': 'MY BUSINESS',
  'humbee-benefits': 'HUMBEE BENEFITS',
  'analytics': 'ANALYTICS',
  'onboard-buyer': 'ONBOARD BUYER'
};
export const useFullMenuStructure = () => {
  const [tokenData, setTokenData] = useState();
  const getTokenData = async () => {
    const decoded = await decodeToken();
    setTokenData(decoded);
  };
  useEffect(() => {
    getTokenData();
  }, []);
    
  let isPwa = false;
  if (tokenData && tokenData?.pwa_module) {
    isPwa = true;
  }
  const { secondaryPermissionsRoles } = useSelector((state) => ({
    secondaryPermissionsRoles: state.loginReducer.secondaryPermissionsRoles,
  }));

  const ORDER_ADMIN = secondaryPermissionsRoles?.includes(secondaryPermission['ORDER_ADMIN']);
  const PAYMENT_ADMIN = secondaryPermissionsRoles?.includes(secondaryPermission['PAYMENT_ADMIN']);
  const COMPANY_ADMIN = secondaryPermissionsRoles?.includes(secondaryPermission['COMPANY_ADMIN']);

  const fullMenuStructure = [
    {
      section: 'MY BUSINESS',
      items: [
        {
          label: 'Create Order',
          key: 'create_order',
          path: '/order-booking/po-select-industry',
          icon: <AddShoppingCartOutlined />,
          isVisible: !isPwa ? ORDER_ADMIN || COMPANY_ADMIN : true,
          title: 'Create Order',
          moduleKey: 'business',
          sectionName : MODULE_TO_SECTION.business
           
        },
        {
          label: 'Purchase Order',
          key: 'purchase_order',
          path: '/order-booking/po-list',
          icon: <PostAddOutlined />,
          isVisible: !isPwa ? PAYMENT_ADMIN || ORDER_ADMIN || COMPANY_ADMIN: true,
          title: 'Purchase Order',
          moduleKey: 'business',
          
        },
        {
          label: 'Dispatch Status',
          key: 'dispatch_order',
          path: '/order-booking/dispatch-status-list',
          icon: <FireTruckOutlined />,
          isVisible: !isPwa ? ORDER_ADMIN || PAYMENT_ADMIN || COMPANY_ADMIN : true,
          title: 'Dispatch Status',
          moduleKey: 'business',
        },
        {
          label: 'Secondary Order',
          key: 'secondary_order',
          path: '/order-booking/secondar-orders-list',
          icon: <LibraryAddOutlined />,
          isVisible:!isPwa ? ORDER_ADMIN || COMPANY_ADMIN : true,
          title: 'Secondary Order',
          moduleKey: 'business',
        },
        {
          label: 'Inventory',
          key: 'inventory',
          path: '/inventory',
          icon: <Inventory2Outlined />,
          isVisible: !isPwa ? PAYMENT_ADMIN || ORDER_ADMIN || COMPANY_ADMIN : true,
          title: 'Inventory',
          moduleKey: 'business',
        },
        {
          label: 'Payment',
          key: 'payment',
          path: '/distributor/payment',
          icon: <PaymentOutlined />,
          isVisible: !isPwa ? PAYMENT_ADMIN || COMPANY_ADMIN : true,
          title: 'Payment',
          moduleKey: 'business',
        },
        {
          label: 'Invoices',
          key: 'invoices',
          path: '/order-booking/completed-invoices',
          icon: <FactCheckOutlined />,
          isVisible: !isPwa ? PAYMENT_ADMIN || ORDER_ADMIN || COMPANY_ADMIN : true,
          title: 'Invoices',
          moduleKey: 'business',
        },
      ],
    },
    {
      section: 'ONBOARD BUYER',
      items: [
        {
          label: 'Onboard Buyer',
          key: 'onboard_buyer',
          path: '/onboard-buyer',
          icon: <PersonAddAlt1Outlined />,
          isVisible: !isPwa ? COMPANY_ADMIN : true,
          moduleKey: 'onboard-buyer',
        },
      ],
    },
    {
      section: 'HUMBEE BENEFITS',
      items: [
        {
          label: 'My Benefits',
          key: 'my_benefits',
          path: '/benefits/mybenefits',
          icon: <MedicalInformationOutlined />,
          isVisible: true,
          moduleKey: 'humbee-benefits',
        },
        {
          label: 'Beneficiary',
          key: 'beneficiary',
          path: '/beneficiary',
          icon: <PeopleAltOutlined />,
          isVisible: true,
          moduleKey: 'humbee-benefits',
        },
        {
          label: 'Cumulative TDS',
          key: 'cumulative_tds',
          path: '/benefits/cumulative-tds',
          icon: <PercentOutlined />,
          isVisible: true,
          moduleKey: 'humbee-benefits',
        },
        {
          label: 'My Rewards',
          key: 'my_rewards',
          path: '/benefits/rewards',
          icon: <CardGiftcardOutlined />,
          isVisible: true,
          moduleKey: 'humbee-benefits',
        },
        {
          label: 'Network Rewards',
          key: 'network_rewards',
          path: '/benefits/network-rewards',
          icon: <CardGiftcardOutlined />,
          isVisible: true,
          moduleKey: 'humbee-benefits',
        },
      ],
    },
    {
      section: 'ANALYTICS',
      items: [
        {
          label: 'Performance',
          key: 'performance',
          path: '/my-performance/Performance',
          icon: <AutoGraphOutlined />,
          isVisible: true,
          moduleKey: 'analytics',
        },
        {
          label: 'Network Performance',
          key: 'network_performance',
          path: '/my-performance/network-performance',
          icon: <AutoGraphOutlined />,
          isVisible: true,
          moduleKey: 'analytics',
        },
      ],
    },
  ];
  const filteredMenuStructure = fullMenuStructure
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => item.isVisible),
    }))
    .filter((section) => section.items.length > 0);

  return filteredMenuStructure;
};
